import FourOFour from './FourOFourView'

export default FourOFour
